export const titleFormatter = (title) => {
    const string = title;
    const stringLength = string.length
    const length = 27;
    let formattedTitle, trimmedTitle
    if (stringLength > length) {
        trimmedTitle = string.substring(0, length) 
        formattedTitle = trimmedTitle + "..."
    } else {
        formattedTitle = title
    }
    return formattedTitle
}